import React from 'react';
import { GovFormWeb } from '@gov-design-system-ce/react-form';
import { useAuthorizedLabel, useLocale } from '@gov-nx/core/service';
import type { PageCode } from '@gov-nx/module/page';
import { useNastaveniKontaktnichUdajuROSItemContext } from '@gov-nx/module/page';
import { Button, ButtonGroupLayout, Dialog, LayoutGap } from '@gov-nx/ui/web';
import { SouhlasCheckbox } from '../../../../Autorizace/SouhlasCheckbox';

interface UsePersonalContactsDialogProps {
	code: PageCode;
	ico: number;
}

export const UsePersonalContactsDialog = ({
	code,
	ico,
}: UsePersonalContactsDialogProps) => {
	const FORM_ID = `use-personal-contacts-consent-form-${ico}`;
	const { t } = useLocale(code);
	const authLabel = useAuthorizedLabel();

	const {
		canUsePersonalContacts,
		isUsingPersonalContactsLoading,
		personalContactsConsent,
	} = useNastaveniKontaktnichUdajuROSItemContext();

	const {
		isDialogOpen,
		isLowAuthorization,
		isAuthorizationEnforced,
		formDefinition,
		onSubmit,
	} = personalContactsConsent;

	return (
		<>
			<Button
				onClick={isLowAuthorization ? isDialogOpen.setTrue : onSubmit}
				isDisabled={!canUsePersonalContacts || isUsingPersonalContactsLoading}
				isLoading={isUsingPersonalContactsLoading}
				color="primary"
				type="solid"
				size="l"
				isExpandedMobile
				aria-label={authLabel(
					t('kontakt.wcag.pouzit-udaje-fyzicke-osoby'),
					isAuthorizationEnforced
				)}>
				{authLabel(
					t('kontakt.action.pouzit-udaje-fyzicke-osoby'),
					isAuthorizationEnforced
				)}
			</Button>

			{isLowAuthorization && (
				<Dialog
					isOpen={isDialogOpen.value}
					onClose={isDialogOpen.setFalse}
					blockClose={isUsingPersonalContactsLoading}
					title={<h3>{t('kontakt.dialog.pouzit-udaje.titulek')}</h3>}
					footer={
						<ButtonGroupLayout>
							<Button
								color="primary"
								type="outlined"
								onClick={isDialogOpen.setFalse}
								isDisabled={isUsingPersonalContactsLoading}>
								{t('kontakt.akce.zrusit')}
							</Button>
							<Button
								color="primary"
								type="solid"
								form={FORM_ID}
								nativeType="submit"
								isLoading={isUsingPersonalContactsLoading}
								isDisabled={isUsingPersonalContactsLoading}>
								{t('kontakt.dialog.pouzit-udaje.potvrdit')}
							</Button>
						</ButtonGroupLayout>
					}>
					<GovFormWeb
						id={FORM_ID}
						onSubmit={onSubmit}
						formDefinition={formDefinition}>
						<LayoutGap gap="m">
							<SouhlasCheckbox
								show
								disabled={isUsingPersonalContactsLoading}
							/>
						</LayoutGap>
					</GovFormWeb>
				</Dialog>
			)}
		</>
	);
};
